export const adjustHue = `
vec3 adjustHue(vec3 color, float hue) {
  float rads = radians(hue);
  vec3 k = vec3(0.57735, 0.57735, 0.57735);
  float cosAngle = cos(rads);
  return vec3(color * cosAngle + cross(k, color) * sin(rads) + k * dot(k, color) * (1.0 - cosAngle));
}
`;
